module.exports = __webpack_public_path__ + "img/3.5129a7d7.jpg";